import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface FabricServiceCardProps {
  title: string;
  imageSrc: string; // Keep it simple - just accept a string path
  slug: string;
  description?: string;
}

const FabricServiceCard = ({ title, imageSrc, slug, description }: FabricServiceCardProps) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    // Navigate to the sub-service page
    navigate(`/services/fabric/${slug}`);
  };

  const handleImageError = () => {
    console.error(`Failed to load image for ${title}`);
    setImageError(true);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transform transition-transform hover:scale-105 relative group"
      onClick={handleClick}
    >
      <div className="relative h-64 w-full bg-gray-200">
        {!imageError && (
          <img 
            src={imageSrc}
            alt={title} 
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        )}
        {imageError && (
          <div className="absolute inset-0 flex items-center justify-center text-gray-500">
            Image not available
          </div>
        )}
        
        {/* Hover Description Overlay */}
        {description && (
          <div className="absolute inset-0 bg-black bg-opacity-70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center p-4">
            <p className="text-white text-center text-sm">{description}</p>
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
      </div>
    </div>
  );
};

export default FabricServiceCard; 